export default __webpack_public_path__ + "static/media/linkedIn_logo.24a254be.svg";